export default {
  methods: {
    parse(val) {
      let number = +val.replace(/[^-\d]/g, '');
      return number === null || isNaN(number) ? 0 : parseInt(number);
    },
    format(val) {
      return val !== null ? val.toLocaleString('es') : '';
    }
  }
};



// WEBPACK FOOTER //
// ./resources/vue/mixins/CurrencyMixin.js